import { isAxiosError } from 'axios';
import { notFound } from '@tanstack/react-router';

export async function goToNotFoundIf404<T>(apiCall: () => Promise<T>): Promise<T> {
  try {
    return await apiCall();
  } catch (error) {
    if (isAxiosError(error) && error.status === 404) {
      throw notFound();
    }
    throw error;
  }
}
